/**
 * Subscription Upgrade Functionality
 * Handles upgrading one-time purchases to subscriptions in the cart drawer
 */

(function() {
  'use strict';

  console.log('[Subscribe & Save] Subscription upgrade script loaded - Global Version');

  // Error handling wrapper
  function safeExecute(fn, context = 'Unknown') {
    try {
      return fn();
    } catch (error) {
      console.error(`[Subscribe & Save] Error in ${context}:`, error);
    }
  }

  // Initialize subscription upgrade functionality
  function initSubscriptionUpgrade() {
    return safeExecute(() => {
      console.log('[Subscribe & Save] Initializing subscription upgrade...');
      
      const upgradeButtons = document.querySelectorAll('.CartItem__SubscriptionButton');
      console.log('[Subscribe & Save] Found upgrade buttons:', upgradeButtons.length);
      
      upgradeButtons.forEach((button, index) => {
        // Guard: this init runs on DOMContentLoaded, cart:refreshed, cart:opened AND
        // cart:refresh. Without this, every run stacks another click listener on the
        // same button, so one click fires several /cart/add.js calls — which is why
        // the quantity sometimes doubled.
        if (button.dataset.suBound === '1') return;
        button.dataset.suBound = '1';

        console.log(`[Subscribe & Save] Setup button ${index+1}:`, {
          key: button.dataset.lineItemKey,
          variantId: button.dataset.variantId,
          sellingPlanId: button.dataset.sellingPlanId,
          quantity: button.dataset.quantity
        });
        
        button.addEventListener('click', function(e) {
          e.preventDefault();
          console.log('[Subscribe & Save] Button clicked!');
          
          const lineItemKey = this.dataset.lineItemKey;
          const variantId = this.dataset.variantId;
          const sellingPlanId = this.dataset.sellingPlanId;
          const quantity = this.dataset.quantity;
          
          console.log('[Subscribe & Save] Starting upgrade process with data:', {
            lineItemKey,
            variantId,
            sellingPlanId,
            quantity
          });
          
          upgradeToSubscription(lineItemKey, variantId, sellingPlanId, quantity, this);
        });
      });
    }, 'initSubscriptionUpgrade');
  }

  // Function to upgrade item to subscription
  function upgradeToSubscription(lineItemKey, variantId, sellingPlanId, quantity, buttonElement) {
    console.log('[Subscribe & Save] Getting current cart state...');
    
    // First get current cart to ensure we have the latest data
    fetch('/cart.js')
      .then(response => {
        console.log('[Subscribe & Save] /cart.js response status:', response.status);
        return response.json();
      })
      .then(cart => {
        console.log('[Subscribe & Save] Cart before upgrade:', {
          itemCount: cart.item_count,
          items: cart.items.map(item => ({
            key: item.key,
            variant_id: item.variant_id,
            quantity: item.quantity,
            product_title: item.product_title,
            selling_plan_allocation: item.selling_plan_allocation
          }))
        });
        
        // Remove the one-time item first
        console.log('[Subscribe & Save] Removing one-time item with key:', lineItemKey);
        
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: lineItemKey,
            quantity: 0
          })
        });
      })
      .then(response => {
        console.log('[Subscribe & Save] /cart/change.js response status:', response.status);
        if (!response.ok) {
          console.error('[Subscribe & Save] Failed to remove item - response not OK:', response);
          throw new Error(`Failed to remove item: ${response.status} ${response.statusText}`);
        }
        return response.json();
      })
      .then(cart => {
        console.log('[Subscribe & Save] Cart after removal:', {
          itemCount: cart.item_count,
          items: cart.items.map(item => ({
            key: item.key,
            variant_id: item.variant_id,
            quantity: item.quantity,
            product_title: item.product_title,
            selling_plan_allocation: item.selling_plan_allocation
          }))
        });
        
        // Then add the subscription version
        console.log('[Subscribe & Save] Adding subscription version', {
          variantId,
          quantity,
          sellingPlanId,
          requestBody: JSON.stringify({
            id: variantId,
            quantity: parseInt(quantity),
            selling_plan: sellingPlanId
          })
        });
        
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: parseInt(quantity),
            selling_plan: sellingPlanId
          })
        });
      })
      .then(response => {
        console.log('[Subscribe & Save] /cart/add.js response status:', response.status);
        if (!response.ok) {
          console.error('[Subscribe & Save] Failed to add subscription - response not OK:', response);
          throw new Error(`Network response was not ok: ${response.status} ${response.statusText}`);
        }
        return response.json();
      })
      .then(data => {
        console.log('[Subscribe & Save] Subscription added successfully:', data);
        
        // Check if the subscription was actually added with selling plan
        if (data.selling_plan_allocation) {
          console.log('[Subscribe & Save] Confirmed subscription plan added:', data.selling_plan_allocation);
        } else {
          console.warn('[Subscribe & Save] Item added but may not have selling plan attached:', data);
        }
        
        console.log('[Subscribe & Save] Dispatching cart:refresh event');
        
        // Refresh the cart - using documentElement as the theme expects
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        
        // Show success feedback
        showSuccessMessage(buttonElement);
      })
      .catch(error => {
        console.error('[Subscribe & Save] Error during upgrade:', error);
        showErrorMessage(buttonElement);
      });
  }

  // Show success message
  function showSuccessMessage(buttonElement) {
    console.log('[Subscribe & Save] Showing success message');
    
    const discountText = buttonElement.querySelector('.CartItem__SubscriptionLabel').dataset.discountText || '';
    const price = buttonElement.querySelector('.CartItem__SubscriptionPrice').textContent || '';
    
    buttonElement.innerHTML = `
      <span class="CartItem__SubscriptionLabel">✓ Upgraded to Subscribe & Save ${discountText}</span>
      <span class="CartItem__SubscriptionPrice">${price}</span>
    `;
    
    buttonElement.style.background = '#10b981';
    buttonElement.style.cursor = 'default';
    
    // Hide the success message after delay and remove the button
    setTimeout(() => {
      if (buttonElement.parentNode) {
        buttonElement.style.opacity = '0';
        setTimeout(() => {
          if (buttonElement.parentNode) {
            buttonElement.parentNode.removeChild(buttonElement);
          }
        }, 300);
      }
    }, 2000);
  }

  // Show error message
  function showErrorMessage(buttonElement) {
    console.log('[Subscribe & Save] Showing error message');
    
    const discountText = buttonElement.querySelector('.CartItem__SubscriptionLabel').dataset.discountText || '';
    const price = buttonElement.querySelector('.CartItem__SubscriptionPrice').textContent || '';
    
    buttonElement.innerHTML = `
      <span class="CartItem__SubscriptionLabel">Subscribe & Save ${discountText}</span>
      <span class="CartItem__SubscriptionPrice">${price}</span>
    `;
    
    // Show error message
    const errorMessage = document.createElement('div');
    errorMessage.className = 'CartItem__SubscriptionError';
    errorMessage.innerHTML = 'Failed to upgrade. Please try again.';
    
    // Insert error message after the button
    buttonElement.parentNode.insertBefore(errorMessage, buttonElement.nextSibling);
    
    // Remove error message after delay
    setTimeout(() => {
      if (errorMessage.parentNode) {
        errorMessage.parentNode.removeChild(errorMessage);
      }
    }, 5000);
  }

  // Initialize subscription upgrade when cart is refreshed
  document.addEventListener('cart:refreshed', function(event) {
    console.log('[Subscribe & Save] cart:refreshed event detected, reinitializing...', event);
    setTimeout(() => {
      initSubscriptionUpgrade();
      initSubscriptionBenefitsModal();
    }, 100); // Small delay to ensure DOM is updated
  });

  // Listen for the cart drawer being opened
  document.addEventListener('cart:opened', function(event) {
    console.log('[Subscribe & Save] Cart opened, checking for upgrade buttons...');
    setTimeout(() => {
      initSubscriptionUpgrade();
      initSubscriptionBenefitsModal();
    }, 500); // Small delay to ensure DOM is updated
  });

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', function() {
    console.log('[Subscribe & Save] DOM loaded, initializing upgrade buttons');
    initSubscriptionUpgrade();
    initSubscriptionBenefitsModal();
    
    // Additional event listener for theme's cart refreshes
    document.documentElement.addEventListener('cart:refresh', function(event) {
      console.log('[Subscribe & Save] Detected cart:refresh event, will reinitialize buttons shortly', event);
      setTimeout(() => {
        initSubscriptionUpgrade();
        initSubscriptionBenefitsModal();
      }, 1000); // Wait for cart to be refreshed
    });
  });

  // Listen for any changes to the cart drawer content
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // Check if any added nodes contain subscription buttons
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            const hasSubscriptionButtons = node.querySelector && node.querySelector('.CartItem__SubscriptionButton');
            const hasBenefitsLinks = node.querySelector && node.querySelector('.CartItem__SubscriptionBenefitsLink');
            if (hasSubscriptionButtons || hasBenefitsLinks) {
              console.log('[Subscribe & Save] New subscription elements detected via MutationObserver');
              setTimeout(() => {
                initSubscriptionUpgrade();
                initSubscriptionBenefitsModal();
              }, 100);
            }
          }
        });
      }
    });
  });

  // Start observing when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    const cartDrawer = document.getElementById('sidebar-cart');
    if (cartDrawer) {
      observer.observe(cartDrawer, {
        childList: true,
        subtree: true
      });
      console.log('[Subscribe & Save] Started observing cart drawer for changes');
    }
  });

  // Subscription Benefits Modal Functionality
  function initSubscriptionBenefitsModal() {
    return safeExecute(() => {
      console.log('[Subscribe & Save] Initializing subscription benefits modal...');
      
      const benefitsLinks = document.querySelectorAll('.CartItem__SubscriptionBenefitsLink[data-action="show-subscription-benefits"]');
      console.log('[Subscribe & Save] Found benefits links:', benefitsLinks.length);
      
      benefitsLinks.forEach((link, index) => {
        // Remove existing event listeners to prevent duplicates
        link.removeEventListener('click', handleShowBenefitsModal);
        link.addEventListener('click', handleShowBenefitsModal);
        console.log(`[Subscribe & Save] Setup benefits link ${index + 1}`);
      });

      // Setup close modal listeners
      const modal = document.getElementById('subscription-benefits-modal');
      if (modal) {
        const closeButtons = modal.querySelectorAll('[data-action="close-subscription-benefits"]');
        closeButtons.forEach(button => {
          button.removeEventListener('click', handleCloseBenefitsModal);
          button.addEventListener('click', handleCloseBenefitsModal);
        });
        
        // Close modal when clicking outside
        const overlay = modal.querySelector('.SubscriptionBenefitsModal__Overlay');
        if (overlay) {
          overlay.removeEventListener('click', handleCloseBenefitsModal);
          overlay.addEventListener('click', handleCloseBenefitsModal);
        }
        
        // Close modal on Escape key
        document.removeEventListener('keydown', handleModalKeydown);
        document.addEventListener('keydown', handleModalKeydown);
        
        console.log('[Subscribe & Save] Setup modal close handlers');
      }
    }, 'initSubscriptionBenefitsModal');
  }

  function handleShowBenefitsModal(e) {
    e.preventDefault();
    console.log('[Subscribe & Save] Show benefits modal clicked');
    
    const modal = document.getElementById('subscription-benefits-modal');
    if (modal) {
      modal.style.display = 'block';
      // Force reflow before adding class for smooth animation
      modal.offsetHeight;
      modal.classList.add('is-visible');
      
      // Prevent body scroll
      document.body.style.overflow = 'hidden';
      
      console.log('[Subscribe & Save] Benefits modal opened');
    }
  }

  function handleCloseBenefitsModal(e) {
    e.preventDefault();
    console.log('[Subscribe & Save] Close benefits modal clicked');
    
    const modal = document.getElementById('subscription-benefits-modal');
    if (modal) {
      modal.classList.remove('is-visible');
      
      // Hide modal after animation completes
      setTimeout(() => {
        modal.style.display = 'none';
        // Restore body scroll
        document.body.style.overflow = '';
      }, 300);
      
      console.log('[Subscribe & Save] Benefits modal closed');
    }
  }

  function handleModalKeydown(e) {
    if (e.key === 'Escape') {
      const modal = document.getElementById('subscription-benefits-modal');
      if (modal && modal.classList.contains('is-visible')) {
        handleCloseBenefitsModal(e);
      }
    }
  }

})();
